var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Technology/folder/alt",
    clipPath: "url(#clip0_717_20905)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.5 17.4998H17.5M10.5 26.8332H17.5C20.7669 26.8332 22.4004 26.8332 23.6482 26.1974C24.7459 25.6381 25.6382 24.7457 26.1975 23.6481C26.8333 22.4003 26.8333 20.7668 26.8333 17.4998V10.4998C26.8333 7.23286 26.8333 5.59938 26.1975 4.35156C25.6382 3.25395 24.7459 2.36156 23.6482 1.8023C22.4004 1.1665 20.7669 1.1665 17.5 1.1665H10.5C7.23299 1.1665 5.5995 1.1665 4.35168 1.8023C3.25407 2.36156 2.36168 3.25395 1.80242 4.35156C1.16663 5.59938 1.16663 7.23286 1.16663 10.4998V17.4998C1.16663 20.7668 1.16663 22.4003 1.80242 23.6481C2.36168 24.7457 3.25407 25.6381 4.35168 26.1974C5.5995 26.8332 7.23299 26.8332 10.5 26.8332ZM9.56663 22.1665H18.4333C19.7401 22.1665 20.3935 22.1665 20.8926 21.9122C21.3317 21.6885 21.6886 21.3315 21.9123 20.8925C22.1666 20.3934 22.1666 19.74 22.1666 18.4332V16.5665C22.1666 15.2597 22.1666 14.6063 21.9123 14.1072C21.6886 13.6681 21.3317 13.3112 20.8926 13.0875C20.3935 12.8332 19.7401 12.8332 18.4333 12.8332H9.56663C8.25984 12.8332 7.60644 12.8332 7.10732 13.0875C6.66827 13.3112 6.31132 13.6681 6.08761 14.1072C5.83329 14.6063 5.83329 15.2597 5.83329 16.5665V18.4332C5.83329 19.74 5.83329 20.3934 6.08761 20.8925C6.31132 21.3315 6.66827 21.6885 7.10732 21.9122C7.60644 22.1665 8.25984 22.1665 9.56663 22.1665Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_717_20905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlt);
export default __webpack_public_path__ + "static/media/alt.fbac0edf19cf2beb9257b5e45ade8c59.svg";
export { ForwardRef as ReactComponent };